import { render } from "./OverdueDetail.vue?vue&type=template&id=1ca2336e&scoped=true&ts=true"
import script from "./OverdueDetail.vue?vue&type=script&lang=ts"
export * from "./OverdueDetail.vue?vue&type=script&lang=ts"

import "./OverdueDetail.vue?vue&type=style&index=0&id=1ca2336e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca2336e"]])

export default __exports__